import src from "IMAGE";
export default { src, width: 400, height: 78, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGgPDY1FCwhncQ4OhFULC19lDQ11cA4OfmAMDGxaCwthAF0NC301CAZPQwkISlcLC2FYCwtjWQsLYVwLC2dQCgpa0c8NhwYuK0kAAAAASUVORK5CYII="};
